import * as React from 'react';
import { Button, Col, Container, Modal, Row, Table, Stack } from 'react-bootstrap';
import { ClientVersionDto } from '../types/ClientVersionDto';
import { ApiVersionDto } from '../types/ApiVersionDto';

type VersionUpdateModalProps = {
    showModal: boolean;
    dismissModal: any;
    clientVersion: ClientVersionDto;
    apiVersion: ApiVersionDto;
}

class VersionUpdateModal extends React.Component<VersionUpdateModalProps> {

    private handleReload(){
        window.location.reload();
    }

    private handleDismissModal(){
        this.props.dismissModal();
    }

    public render(){

        return(
            <Modal size="lg" show={this.props.showModal} onHide={() => this.handleDismissModal()}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        New Version Available
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Container>
                        <Row>
                            <Col>
                                <p>A newer version of this application may be available. To load the new version, click the Reload button below.</p>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Table borderless size="sm">
                                    <tbody>
                                        <tr>
                                            <td className="font-weight-bold">Server Version:</td>
                                            <td><span className="font-monospace">{this.props.apiVersion.informationalVersion}</span></td>
                                        </tr>
                                        <tr>
                                            <td className="font-weight-bold">Client Version:</td>
                                            <td><span className="font-monospace">{this.props.clientVersion.version}</span> <small>(older)</small></td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <p><small>Note: Continuing to run with an outdated client may result in unpredictable behavior.</small></p>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Stack direction="horizontal" gap={3}>
                                    <Button variant="primary" onClick={() => this.handleReload()}>Reload</Button>
                                    <Button variant="danger" onClick={() => this.handleDismissModal()}>Cancel</Button>
                                </Stack>
                            </Col>
                        </Row>
                    </Container>
                </Modal.Body>
            </Modal>
        );
    }
}

export default VersionUpdateModal;